import { ESCAPE_KEY } from "constants/keys.constants";

// Keyboard policy for the selected-well spacing measurement (EVA-29): Escape
// releases the pinned well. Kept as a pure predicate so the edge cases — a user
// typing Escape inside a field, or the screenshot overlay owning the key — are
// unit-testable without mounting the viewer.

/** True for elements where Escape belongs to the field, not the scene. */
export const isEditableEventTarget = (target: EventTarget | null): boolean => {
  const element = target as HTMLElement | null;
  if (!element || typeof element.tagName !== "string") {
    return false;
  }
  const tag = element.tagName.toLowerCase();
  return (
    tag === "input" ||
    tag === "textarea" ||
    tag === "select" ||
    element.isContentEditable === true
  );
};

/**
 * Whether a keydown should release the pinned spacing selection.
 *
 * Ignored while the screenshot overlay is open so Escape keeps whatever
 * meaning that surface gives it, and ignored for text entry.
 */
export const shouldClearSpacingSelection = (
  key: string,
  target: EventTarget | null,
  isScreenshotOverlayVisible: boolean
): boolean =>
  key === ESCAPE_KEY && !isScreenshotOverlayVisible && !isEditableEventTarget(target);
